import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useSyndeticsConfig } from "@tlc/ls2pac/components/SyndeticsConfig";
import React, { useEffect, useState } from "react";
import { ResourceDWR } from "../../../../dto/ResourceDWR";
import {
  getISBNList,
  getUPCList,
} from "@tlc/ls2pac/app/utils/PACStandardNumberUtil";
import {
  LibraryThingEnrichment,
  LibraryThingMetaData,
  SyndeticsUnboundUtil,
} from "@tlc/syndetics-util";
import { SyndeticsTermsLink } from "./SyndeticsTermsLink";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UnboundClasses } from "./SyndeticsRelatedContent";

export interface SyndeticsReviewsProps {
  resource: ResourceDWR;
}
export const SyndeticsReviews = ({ resource }: SyndeticsReviewsProps) => {
  const { hasReviewsTabEnrichments, util, syndeticsConfig } =
    useSyndeticsConfig();
  const id = `resource_${resource?.id}_reviews`;
  const { translate } = useLanguage();
  const [loading, setLoading] = useState<boolean>(true);
  const [hasContent, setHasContent] = useState<boolean>();
  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (resource?.id && hasReviewsTabEnrichments) {
    }
    const refreshMetaData = async () => {
      var isbn = getISBNList(resource.standardNumbers);
      var upc = getUPCList(resource.standardNumbers);
      const metaData: LibraryThingMetaData = {
        unbound_containing_selector: `#${id}`,
        title: resource.shortTitle,
        author: resource.shortAuthor,
        isbn: isbn,
        upc: upc,
        usemegadiv: false,
        branchFilters: syndeticsConfig.branchFilters,
      };
      try {
        const { errors, enrichmentsShown } = await util.refreshMetaData(
          metaData
        );

        const hasContent = enrichmentsShown?.includes(
          LibraryThingEnrichment.ProfessionalReviews
        );
        setHasContent(hasContent);
        if (hasContent) {
          setExpanded(true);
        }
      } catch (e: unknown) {
        // TODO unable to load
        console.error(e);
        setHasContent(false);
      } finally {
        setLoading(false);
      }
    };
    if (
      util &&
      syndeticsConfig?.active &&
      hasReviewsTabEnrichments &&
      resource?.id
    ) {
      refreshMetaData();
    }
  }, [util, syndeticsConfig?.active, hasReviewsTabEnrichments, resource?.id]);

  if (!hasReviewsTabEnrichments) {
    return null;
  }
  return (
    <>
      {/* We want slightly different behavior here than EnrichmentSection, treating as a one off */}
      <Accordion
        // disabled={loading}
        expanded={expanded}
        onChange={(_, e) => setExpanded(e)}
      >
        <AccordionSummary
          expandIcon={
            loading ? (
              <CircularProgress size="24px" color="inherit" />
            ) : (
              <ExpandMoreIcon />
            )
          }
        >
          <Typography>
            {SyndeticsUnboundUtil.EnrichmentLabel.get(
              LibraryThingEnrichment.ProfessionalReviews
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          className={UnboundClasses[LibraryThingEnrichment.ProfessionalReviews]}
        >
          {!hasContent && !loading && <>{translate("noEditorialReviews")}</>}
        </AccordionDetails>
      </Accordion>
      <SyndeticsTermsLink />
    </>
  );
};
